import React from "react";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Radar } from "react-chartjs-2";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

const RadarChart = ({ data }) => {
  const colorPalete = [
    {
      backgroundColor: "rgba(255, 190, 11, 0.2)",
      borderColor: "rgb(255, 190, 11)",
    },
    {
      backgroundColor: "rgba(255, 0, 110, 0.2)",
      borderColor: "rgb(255, 0, 110)",
    },
    {
      backgroundColor: "rgba(58, 134, 255, 0.2)",
      borderColor: "rgb(58, 134, 255)",
    },
    {
      backgroundColor: "rgba(6, 214, 160, 0.2)",
      borderColor: "rgb(6, 214, 160)",
    },
  ];

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Research interest",
      },
    },
  };

  let labels = [];
  let datasets = [];
  data.map((item) => {
    item.keywords.slice(0, 5).map((key) => {
      labels.push(key.value);
    });
  });
  data.map((item, i) => {
    let data_label = Array(labels.length).fill(0);
    item.keywords.slice(0, 5).map((key) => {
      const index = labels.indexOf(key.value);
      if (index != -1) {
        data_label[index] = key.score;
      }
    });
    datasets.push({
      label: item.name,
      data: data_label,
      backgroundColor: colorPalete[i].backgroundColor,
      borderColor: colorPalete[i].borderColor,
      borderWidth: 1,
    });
  });

  return (
    <Radar options={options} data={{ labels: labels, datasets: datasets }} />
  );
};

export default RadarChart;
